import { callEdge } from "@/lib/edgeClient"

export interface QuickMetrics {
  users: number
  uptime: number // percentage
  avgResponse: number // milliseconds
  pendingApprovals: number
}

export async function getQuickMetrics(): Promise<QuickMetrics> {
  try {
    const data = await callEdge("admin-metrics-quick", {
      method: "GET",
      authRequired: true,
    })
    return data as QuickMetrics
  } catch (error) {
    // Edge Function not deployed - fail silently for UI to handle
    console.warn("[getQuickMetrics] Edge Function not available:", error instanceof Error ? error.message : error)
    throw error
  }
}

